import {Component, OnDestroy, OnInit} from '@angular/core';
import * as fromApp from '../../../store/app.reducers';
import {ProfileService} from '../../profile.service';
import {FormControl, UntypedFormGroup, Validators} from '@angular/forms';
import * as PostActions from '../store/post.actions';
import {Store} from '@ngrx/store';
import {Subscription} from 'rxjs';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'app-post-add',
    templateUrl: './post-add.component.html',
    styleUrls: ['./post-add.component.scss'],
    standalone: false
})
export class PostAddComponent implements OnInit, OnDestroy {

  profileForm: UntypedFormGroup;
  hasLimit: boolean;
  hasLimitSubscribe: Subscription;

  constructor(
    private store: Store<fromApp.AppState>,
    private profileService: ProfileService,
    private notifierService: ToastrService
  ) { }

  ngOnInit() {
    this.initForm();
    this.hasLimitSubscribe = this.profileService.hasActivePostLimit().subscribe(
      (hasLimit: boolean) => {
        this.hasLimit = hasLimit;
      }
    );
  }

  onPaste(event: ClipboardEvent) {
    const regex = /(?:(?:http|https):\/\/)?(?:www.)?(?:instagram.com|instagr.am)\/p\/([A-Za-z0-9-_\.]+)/i;
    this.profileForm.controls['post'].reset();

    const clipboardData = event.clipboardData;
    const pastedText = clipboardData.getData('text');
    const reg = pastedText.match(regex);
    let array = [];
    if (reg !== null) {
      array = [...reg];
      if (array.length === 2) {
        this.profileForm.controls['post'].reset(array[1]);
        setTimeout(() => {
          const actualRegex = this.profileForm.value.post.replace(pastedText, '');
          this.profileForm.controls['post'].reset(actualRegex);
        }, 100);
      }
    }
  }

  onSubmit() {
    const post = this.profileForm.value.post.trim();
    if (this.hasLimit) {
      this.store.dispatch(
        new PostActions.AddAudit(post)
      );
    } else {
      this.notifierService.warning('You have no credits');
    }

  }

  initForm() {
    this.profileForm = new UntypedFormGroup({
      'post': new FormControl(null, Validators.required)
    });
  }

  ngOnDestroy() {
    this.hasLimitSubscribe.unsubscribe();
  }

}
